import CTYPE from 'constants/ctype.const';
import beVersion1 from 'middleware/beVersion1';
import beVersion3 from 'middleware/beVersion3';
import beVersion4 from 'middleware/beVersion4';

const fromBeToBody = (result) => {
  if (!result) return void 1;

  if (result.MTAG === beVersion4.MTAG) return result.ctype === CTYPE.text ? result.text : result.json;
  if (result.MTAG === beVersion3.MTAG) return result.ctype === CTYPE.text ? result.text : result.json;

  // in v1, there is an internal check for ctype and based of that, the field response is either equal to text or json
  if (result.MTAG === beVersion1.MTAG) return result.response;

  return result.response;
};

export default fromBeToBody;
